import gql from "graphql-tag";
const getCalcResultQuery = gql(` 
query GetCalcResult($params: AWSJSON!) {
  getCalcResult(params: $params) {
    id
    status
    profile
    nearest
    coords
    distance
    geo
    quantity
    filtered
    result
    sampleResult
    groupResult
    mapResult
    meta
    version
  }
}
`)
export default getCalcResultQuery;
